import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import dayjs from 'dayjs';
import React, { useCallback, useState } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  DateTimeFormatter,
  DATE_PICKER_DATE_FORMAT,
  DATE_TIME_FORMAT
} from '@nile/components';
import { EditIcon } from '@nile/components/src/Icons';

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;

  .react-datepicker__tab-loop {
    position: fixed;
    z-index: 1;
    .react-datepicker-popper {
      transform: none !important;
    }
  }
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
  padding-right: 8px;
  max-width: 100%;
`;

const DateCell = (props) => {
  const editable = props?.editable || false;
  const displayVal = props?.value;
  const [popoverActive, setPopoverActive] = useState(false);
  const [currentVal, setCurrentVal] = useState(props?.value || '');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  // TODO: Set date format after bug fixed in backend
  const handleChange = useCallback((val) => {
    const date = new Date(val);
    const formatted = dayjs(date).format(DATE_TIME_FORMAT);
    // console.log(date); //original
    // console.log(dayjs(date).format(DATE_TIME_FORMAT)); //formatted
    // console.log(dayjs(formatted).toDate()); //back to original
    // props.handleChange(formatted, type);
    setCurrentVal(formatted);
  });

  const onSaveAction = () => {
    props.handleUpdate(props.property, currentVal);
    togglePopoverActive();
  };

  const onCancelAction = () => {
    togglePopoverActive();
  };

  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div title={displayVal}>
        {displayVal ? (
          <div className="name">
            <DateTimeFormatter type="dateTime" date={displayVal} />
          </div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div title={displayVal}>
        {displayVal ? (
          <div className="name">
            <DateTimeFormatter type="dateTime" date={displayVal} />
          </div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        <Field>
          <DatePicker
            selected={currentVal && dayjs(currentVal).toDate()}
            onChange={handleChange}
            placeholderText="Select Date"
            dateFormat={DATE_PICKER_DATE_FORMAT[DATE_TIME_FORMAT]}
            showTimeInput
          />
          <div className="mt10">
            <ButtonGroup>
              <Button onClick={onCancelAction}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <Button primary onClick={onSaveAction}>
                <FormattedMessage id="common.save" />
              </Button>
            </ButtonGroup>
          </div>
        </Field>
      </Popover>
    </Wrap>
  );
};

export default DateCell;
